import React from "react";
import { CheckSvg } from "../../components/WhatMakesSvg";

function TheMagicSection() {
  return (
    <div className="bg-bird-background-sm lg:bg-bird-background-lg h-screen w-full bg-cover bg-center bg-no-repeat">
      <div className="flex flex-col lg:justify-center lg:px-[120px] p-6 lg:p-0 h-full gap-4 lg:gap-[14px]">
        <p className="max-w-full lg:max-w-[456px] font-semibold text-2xl leading-[36px] lg:text-2xl lg:text-[35px] lg:leading-[54px] text-white">
          The magic of ManipalCigna Sarvah Health Insurance
        </p>
        <p className="max-w-full lg:max-w-[620px] text-white opacity-90 text-base leading-6 lg:text-xl lg:leading-[32px]">
          Experience Essential Shield, Infinite Power and Instant Peace of Mind
          with ManipalCigna Sarvah – a complete health insurance solution Bharat
          needed.
        </p>
        <ul className="max-w-full lg:max-w-[620px] text-white opacity-90 text-base leading-6 lg:text-xl lg:leading-[32px]">
          <li className="flex gap-4 items-start">
            <CheckSvg fill="#FB7C2F" className={"lg:h-8 lg:w-8 h-6 w-6"} />
            <p>Essential Shield - Get coverage up to 3 Crs</p>
          </li>
          <li className="flex gap-4 items-start">
            <CheckSvg fill="#FB7C2F" className={"lg:h-8 lg:w-8 h-6 w-6"} />
            <p>Infinite Power - Get Infinite coverage for Major illnesses</p>
          </li>
          <li className="flex gap-4 items-start">
            <CheckSvg fill="#FB7C2F" className={"lg:h-8 lg:w-8 h-6 w-6"} />
            <p>
              Instant Peace - Get coverage from Day 1, enjoy zero waiting period
            </p>
          </li>
        </ul>
        <p className="max-w-full lg:max-w-[620px] text-white opacity-90 text-base leading-6 lg:text-xl lg:leading-[32px]">
          Sarvah has got many benefits, whether you’re looking for essential
          care or unlimited benefits, Sarvah has got you covered. With Sarvah,
          Sada Secure Raho!
        </p>
      </div>
    </div>
  );
}

export default TheMagicSection;
